module.exports = {"430471401":"衡阳综合保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430471.json
// module id = 1967
// module chunks = 0